module.exports = __webpack_public_path__ + "img/code-circle-02.035039b2.svg";